
import React from 'react';
import Avatar from '@mui/material/Avatar';
import './style.css';

const TypingIndicator = ({ avatar, bgColor, letter }) => (
    <div className="Message-User-Container-left" style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '8px 0' }}>
      <div className="avatarContainer">
        {avatar ? (
          <img
            src={avatar}
            alt="Agent Avatar"
            style={{ width: '36px', height: '36px', borderRadius: '50%' }}
          />
        ) : (
          <Avatar sx={{ width: 36, height: 36, bgcolor: bgColor, fontSize: 18, fontWeight: 500 }}>
            {letter}
          </Avatar>
        )}
      </div>
      <div className="typing-indicator-dots" style={{ display: 'flex', alignItems: 'center', gap: 4, marginBottom: 8 }}>
        <span className="typing-dot" style={{ backgroundColor: '#148DFD' }}></span>
        <span className="typing-dot" style={{ backgroundColor: '#148DFD' }}></span>
        <span className="typing-dot" style={{ backgroundColor: '#148DFD' }}></span>
      </div>
    </div>
  );

export default TypingIndicator;